// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#IconMenuList-menu {\n  border-radius: 16px;\n  background-image: linear-gradient(\n    rgba(255, 255, 255, 0.12),\n    rgba(255, 255, 255, 0.12)\n  );\n  background-color: rgb(18, 18, 18);\n  z-index: 999;\n}\n\n.IconMenuList ul.MuiMenu-list {\n  padding: 0;\n}\n\n.IconMenuList li.MuiMenuItem-gutters {\n  padding: 0;\n  min-height: unset;\n  cursor: unset;\n}\n\n.IconMenuList li.MuiMenuItem-gutters:hover {\n  background-color: inherit;\n}\n", ""]);
// Exports
module.exports = exports;
